import React, { useState, useRef, useEffect } from "react"

import "./PatientProfile.css"
import "../Commons/Commons.css"
import "chart.js/auto"

import backarrow from "../../Assets/Icons/back-arrow.png"
import SidebarMenu from "../Sidebar/Sidebar"
import PatientCard from "./PatientCard"
import BtnSave from "../Commons/Buttons/BtnSave"
import Laboratory from "../Laboratory/Laboratory"
import AssessmentHistory from "../AssessmentHistory/AssessmentHistory"
import Radiology from "../Radiology/Radiology"
import Xray from "../Radiology/Xray"
import Ultrasound from "../Radiology/Ultrasound"
import CTScan from "../Radiology/CTScan"
import Others from "../Radiology/Others"
import HealthScreening from "../HealthScreening/HealthScreening"
import PatientScannedProfile from "../PatientScannedFiles/PatientScannedFiles"
import AddMedical from "../MedicalHistory/AddMedical"
import { createQueueSlipFile } from "../QueueSlip/QueueSlipUtils"
import QueueSlip from "../QueueSlip/QueueSlip"
import { handleApiPrint } from "../Helpers/PrintUtils"
import MedicalAbstract from "../Forms/MedicalAbstract/MedicalAbstract"
import MedicalSummary from "../Forms/MedicalSummary/MedicalSummary"
import TheraputicsHistory from "../Theraputics/TheraputicsHistory"
import LaboratoryResults from "../Laboratory/LaboratoryResults"
import MedicalChart from "../MedicalChart/MedicalChart"
import CheckupTabs from "../../Pages/CheckupTabs/CheckupTabs"
import { PhilHealthMedicalRecord } from "../PhilHealth/MedicalRecord"
import { KonsultaManager } from "../PhilHealth/KonsultaManager"
import AddSocialPersonal from "../SocialPersonalHistory/AddSocialPersonal";
// import LaboratoryTabs from "../Laboratory/LaboratoryTabs";
import AppointmentModal from "../Modals/AppointmentModal"
import AddToQueueModal from "../Modals/AddToQueueModal"
import RoutingSlipModal from "../Modals/RoutingSlipModal"
import VitalSigns from "./VitalSigns"
import DeleteModal from "../Modals/DeleteModal"
import MedicalCertificateForm from "../Forms/MedicalCertificate/MedicalCertificateForm"
import ReferralLetterForm from "../Forms/ReferralLetter/ReferralLetterForm"
import AllergyCard from "./AllergyCard"
import FormHistory from "../Forms/FormHistory/FormHistory"
import TableSpinner from "../../Components/TableSpinner/TableSpinner"

import { Alert, Row, Col } from "react-bootstrap"
import { useNavigate, useParams, useLocation } from "react-router-dom"
import { Card } from "antd"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js"
import {
  deletePatient,
  getPatientID,
} from "../Helpers/API/PatientApi/PatientApi"
import { getAllDoctors } from "../Helpers/API/DoctorApi/DoctorApi"
import { createSchedule } from "../Helpers/API/FollowUpPatientsApi/FollowUpPatientsApi"
import { toast } from "react-toastify"
import {
  getQueuedPatients,
  setFPEDone,
  createBookings,
} from "../Helpers/API/QueueApi/QueueApi"
import { createPayment, generateReceipt } from "../Helpers/API/PaymentApi/PaymentApi"
import {
  getIsCheck,
  getOpenAppointmentModal,
  getRole,
  getTomorrowDate,
  getUser,
} from "../Helpers/Utilities/Common"
import { getAssessmentHistory } from "../Helpers/API/AssessmentApi/AssessmentApi"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons"
import { getAllergy } from "../Helpers/API/MedicalHistoryApi/MedicalHistoryApi"
import { Tabs } from "antd"

const { TabPane } = Tabs
function PatientProfile() {
  const role = getRole()
  // const isTrue = getIsTrue();
  const openAppointment = getOpenAppointmentModal()
  const isCheck = getIsCheck()
  const targetDivRef = useRef(null)
  const laboratoryDivRef = useRef(null)
  const queueSlipRef = useRef(null)
  // const targetLabDivRef = useRef(null);
  const navigateto = useNavigate()
  const { state } = useLocation()
  const { id } = useParams()
  const [selectedCheckUpTab, setSelectedCheckUpTab] = useState("checkup")
  const [showDelete, setShowDelete] = useState(false)
  const [showCheckupTabs, setShowCheckupTabs] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [patientDetails, setpatientDetails] = useState([])
  const [selectedTab, setSelectedTab] = useState("")
  const [selectedLabTab, setSelectedLabTab] = useState("laboratory")
  const [selectedFormTab, setSelectedFormTab] = useState("medical_cert")
  const [selectedPhilHealthTab, setSelectedPhilHealthTab] =
    useState("medical_record")
  const [isClicked, setIsClicked] = useState(false)
  const [showAppointmentModal, setShowAppointmentModal] = useState(false)
  const [showAddToQueueModal, setShowAddToQueueModal] = useState(false)
  const [selectedDoctor, setSelectedDoctor] = useState(null)
  const [doctors, setDoctors] = useState([])
  const [complaint, setComplaint] = useState("")
  const [hasPriorAssessment, setHasPriorAssessment] = useState(false)
  const [assessment, setAssessment] = useState({})
  const [queueInfo, setQueueInfo] = useState({})
  const [appointmentDate, setAppointmentDate] = useState(
    new Date(getTomorrowDate()).toISOString().split("T")[0]
  )
  const [isForConsultation, setIsForConsultation] = useState("no")
  const [hasQueued, setHasQueued] = useState(false)
  const [isQueueChecking, setIsQueueChecking] = useState(false)

  const [showRoutingSlipModal, setShowRoutingSlipModal] = useState(false)
  const [bookingResponse, setBookingResponse] = useState(null)
  const [enableAddToQueue, setEnableAddToQueue] = useState(false)
  const [printQueueNo, setPrintQueueNo] = useState("")
  const enableAddToQueueRef = useRef(false)
  const queueNoFromConsultRef = useRef(null)
  const queueIdFromConsultRef = useRef(null)
  const [canShowAddToQueue, setCanShowAddToQueue] = useState(false) // Track if allowed to show Add to Queue button

  const [showLabForm, setShowLabForm] = useState(false)
  const [allergyData, setAllergyData] = useState([])
  const [smokingData, setSmokingData] = useState([])
  const handleShowLabForm = (data) => {
    setShowLabForm(data)
  }
  // Then in your component
  const [medicalHistory] = useLocalStorage("medicalHistory", "")
  const [chiefComplaint] = useLocalStorage("chiefComplaint", "")

  //Function that will redirect you to edit profile
  function handleEdit() {
    navigateto("/patients/edit/" + id)
  }

  //Function that will delete the profile API
  async function handleDeletePatient() {
    const response = await deletePatient(id)
    if (response.data?.status === 200) {
      toast.success(response.data.data[0])
      setShowDelete(false)
      setTimeout(function () {
        navigateto("/patients")
      }, 1000)
    } else {
      toast.error(response.error.data.response)
    }
  }

  // Function get for patient API
  async function fetchPatient() {
    setIsLoading(true)
    // Only reset queue states if NOT coming from Consult button
    if (!queueNoFromConsultRef.current) {
      setEnableAddToQueue(true)
      enableAddToQueueRef.current = true
      setHasQueued(false)
      setBookingResponse(null)
    }
    
    const response = await getPatientID(id, "", "")
    if (response?.data) {
      const patient = response?.data?.data[0]

      const address = [
        patient?.street,
        patient?.barangay,
        patient?.province,
        patient?.city,
        patient?.zip_code,
      ]
        .filter(Boolean) // remove null/undefined/empty values
        .join(", ")

      setpatientDetails({
        ...patient,
        address,
      })
    } else {
      setpatientDetails([])
    }
    setIsLoading(false)
  }

  // Function for adding schedule of patient API
  const onSetAppointment = async () => {
    setIsClicked(true)
    const res = await createSchedule({
      patient_id: id,
      scheduled_on: appointmentDate,
      doctor_id: selectedDoctor !== null ? selectedDoctor : "",
    })
    if (res.data) {
      toast.success(res.data.message)
      setShowAppointmentModal(false)
    } else if (res.error) {
      toast.error(res.error.data.messages.error_messages[0])
    }
    setIsClicked(false)
  }

  // Function for adding patient to queue
  const onAddToQueue = async (action, doctorId, masterDoctorId, doctorName) => {
    if (isClicked || (!enableAddToQueue && hasQueued)) return
    
    // Get the current queue being served from localStorage (set by Dashboard)
    const currentQueueStr = localStorage.getItem("queue_id")
    const currentQueue = currentQueueStr ? JSON.parse(currentQueueStr) : null
    
    // Use queue_id from Consult button if available, otherwise from localStorage
    const queueIdToUse = queueIdFromConsultRef.current || currentQueue?.id || ""
    const queueNoToUse = queueNoFromConsultRef.current || currentQueue?.queue_no || ""
    
    if (action === "proceed") {
      setIsClicked(true)
      try {
        // Step 1: Create Queue (pass the current queue_id to link/end it)
        const queueRes = await createBookings({
          patient_id: id,
          doctor_id: doctorId,
          master_doctor_id: masterDoctorId,
          doctor_name: doctorName,
          queue_id: queueIdToUse, // Pass queue_id from Consult or localStorage
        })
        
        if (queueRes?.data) {
          // Step 2: Set FPE Done
          await setFPEDone({ patient_id: id })
          
          // Clear the queue_id from localStorage so dashboard refreshes
          localStorage.removeItem("queue_id")
          
          toast.success(queueRes.data.message || "Patient queued successfully")
          setHasQueued(true)
          
          if (patientDetails?.master_patient_id) {
            try {
              window.localStorage.setItem(
                `csrQueued:${patientDetails.master_patient_id}`,
                JSON.stringify(true)
              )
            } catch (e) {}
          }
          
          fetchQueueNumber()
          setShowAddToQueueModal(false)
          
          // Step 3: Show Routing Slip Modal after successful booking
          setBookingResponse({
            ...queueRes.data,
            doctor_name: doctorName, // Ensure doctor name is preserved for Routing Slip
            queue_no: queueRes?.data?.data?.queue_no || queueRes?.data?.queue_no || queueNoToUse, // Robust queue_no check
            queue_id: queueIdToUse, // Include queue_id from Consult
          })
          setShowRoutingSlipModal(true)
        } else if (queueRes?.error) {
          toast.error(
            queueRes?.error?.data?.messages?.error_messages?.[0] || "An error occurred creating queue"
          )
        }
      } catch (error) {
        toast.error("An error occurred during queue process")
      }
      setIsClicked(false)
    } else if (action === "no") {

      try {
        // Step 1: Set FPE Done
        await setFPEDone({ patient_id: id })
        
        // Clear the queue_id from localStorage so dashboard refreshes
        localStorage.removeItem("queue_id")
        
        toast.success("Queue ended and FPE marked as done")
        setHasQueued(true) // Disable Add to Queue button after "No" action
        setShowAddToQueueModal(false)
      } catch (error) {
        toast.error("An error occurred")
      }
    }
  }

  // Handler for when routing slip print is done - directly create payment
  const handleRoutingSlipPrintDone = () => {
    setShowRoutingSlipModal(false)
    // Directly call handleCreatePayment with 'no' for additional_transaction
    handleCreatePayment("no")
  }

  // Handler for creating payment
  const handleCreatePayment = async (additionalTransaction) => {
    setIsClicked(true)
    try {
      // Build items array from booking data
      const bookings = bookingResponse?.data?.bookings || bookingResponse?.bookings || []
      const consultationBooking = bookings.find(item => 
        item.details_type === "consultation" || item.transaction_type === "consultation"
      )
      
      const items = consultationBooking ? [{
        name: `Consultation Fee ( ${consultationBooking.doctor_name || "Doctor"} )`,
        quantity: 1,
        price: consultationBooking.price || consultationBooking.amount || 0,
        amount: consultationBooking.price || consultationBooking.amount || 0,
      }] : []
      
      const totalAmount = items.reduce((sum, item) => sum + item.amount, 0)
      const transactionId = bookingResponse?.data?.transaction_id || bookingResponse?.transaction_id || ""
      const transactionNo = bookingResponse?.data?.transaction_no || bookingResponse?.transaction_no || ""
      const customerName = `${patientDetails?.first_name || ""} ${patientDetails?.middle_name || ""} ${patientDetails?.last_name || ""}`.trim()
      
      const paymentPayload = {
        patient_id: id,
        master_patient_id: patientDetails?.master_patient_id || "",
        transaction_id: transactionId,
        amount_and_types: [{ type: "cash", amount: 0.0 }],
        grand_total: 0.0,
        discount: 0.0,
        payment_discount: 0.0,
        change: 0.0,
        charge_to: "",
        is_senior: 0,
        is_pwd: 0,
        additional_transaction: additionalTransaction,
      }
      
      const paymentRes = await createPayment(paymentPayload)
      
      if (paymentRes?.data) {
        toast.success(paymentRes.data.message || "Payment created successfully")
        
        // Generate receipt after successful payment
        // Priority: payment response emr_queue_no -> createBookings -> other sources
        const queueNo = paymentRes?.data?.emr_queue_no ||
                        paymentRes?.data?.emr_response?.queue_no ||
                        paymentRes?.data?.emr_response?.queue_number ||
                        paymentRes?.data?.queue_no || 
                        bookingResponse?.queue_no || 
                        queueInfo?.queue_number || 
                        queueNoFromConsultRef.current || 
                        ""
        
        console.log("generateReceipt check:", { 
          paymentResData: paymentRes?.data,
          bookingResponse, 
          queueInfo, 
          queueNoFromConsultRef: queueNoFromConsultRef.current,
          queueNo 
        })
        
        if (queueNo) {
          console.log("Calling handleApiPrint with queue_no:", queueNo)
          setPrintQueueNo(queueNo) // Set queue number for QueueSlip component
          
          // Wait for queue slip to render then print
          await new Promise(resolve => setTimeout(resolve, 1000)) // 1 second delay like working code
          
          // Use handleApiPrint like working code
          const paymentData = {
            emr_queue_no: queueNo
          }
          
          const receiptRes = await handleApiPrint(
            queueSlipRef, 
            "Cashier", 
            0, 
            'queueSlip.txt', 
            paymentData, 
            false, 
            []
          )
          
          if (receiptRes?.data) {
            console.log("Receipt generated successfully:", receiptRes.data)
          } else if (receiptRes?.error) {
            console.error("Receipt generation failed:", receiptRes.error)
            toast.error("Failed to print queue slip")
          }
        } else {
          console.log("No queue number found, skipping generateReceipt")
        }
        
        if (additionalTransaction === "yes") {
          // Enable Add to Queue button for new transaction
          setEnableAddToQueue(true)
          enableAddToQueueRef.current = true
          setHasQueued(false)
        } else {
          // Disable Add to Queue button and redirect to dashboard
          setEnableAddToQueue(false)
          enableAddToQueueRef.current = false
          navigateto("/dashboard")
        }
      } else if (paymentRes?.error) {
        toast.error(
          paymentRes?.error?.data?.messages?.error_messages?.[0] || "An error occurred creating payment"
        )
      }
    } catch (error) {
      toast.error("An error occurred during payment creation")
    }
    setIsClicked(false)
  }

    // Function for get Assessment API
  async function fetchAssessmentHistory(data) {
    const res = await getAssessmentHistory({
      patient_id: id,
      ...data,
    })
    if (res.data) {
      setAssessment(res.data.data[0])
    } else if (res.error) {
      setAssessment({})
    }
  }

  // Function to check if the patient has a pending assessment API
  async function checkIfPatientHasPriorAssessment() {
    const res = await getAssessmentHistory({
      patient_id: id,
    })
    if (res.data) {
      if (res.data.data.length > 0) {
        setHasPriorAssessment(true)
      } else {
        setHasPriorAssessment(false)
      }
    } else if (res.error) {
      setHasPriorAssessment(false)
    }
  }

  // Function for getting the queue number of patient API
  async function fetchQueueNumber() {
    setIsQueueChecking(true)
    if (state?.fromConsult) {
      setQueueInfo({})
      setHasQueued(false)
      setIsQueueChecking(false)
      return
    }
    const res = await getQueuedPatients({
      status: "queued",
      patient_id: id,
    })
    if (res?.data?.data?.length > 0) {
      setQueueInfo(res.data.data[0])
      // Only set hasQueued if enableAddToQueue is false (not allowing new transaction)
      if (!enableAddToQueueRef.current) {
        setHasQueued(true)
      }
      setIsQueueChecking(false)
      return
    }
    const res2 = await getQueuedPatients({
      status: "queued",
      patient_id: id,
      is_phic_member: 1,
    })
    if (res2?.data?.data?.length > 0) {
      setQueueInfo(res2.data.data[0])
      // Only set hasQueued if enableAddToQueue is false (not allowing new transaction)
      if (!enableAddToQueueRef.current) {
        setHasQueued(true)
      }
      setIsQueueChecking(false)
      return
    }
    setQueueInfo({})
    try {
      const flag =
        patientDetails?.master_patient_id &&
        JSON.parse(
          window.localStorage.getItem(
            `csrQueued:${patientDetails.master_patient_id}`
          ) || "false"
        )
      if (flag && !enableAddToQueueRef.current) {
        setHasQueued(true)
      } else {
        setHasQueued(false)
      }
    } catch (e) {
      setHasQueued(false)
    }
    setIsQueueChecking(false)
  }

  // Function for get Allergy API
  async function fetchAllergy() {
    const response = await getAllergy({ patient_id: id })
    if (response.data) {
      setAllergyData(response.data.data)
    } else {
      setAllergyData([])
    }
  }

  // Function for get all doctors API
  async function fetchAllDoctors() {
    const response = await getAllDoctors()
    if (response.data) {
      const mappedDoctors = response.data.data.map((doctor) => ({
        label: doctor.doctor_name,
        value: doctor.id,
        id: doctor.id,
        doctor_name: doctor.doctor_name,
      }))
      setDoctors(mappedDoctors)
      // setDoctors(response.data.data);
    } else {
      setDoctors([])
    }
  }

  useEffect(() => {
    // Check if coming from Register Patient or Consult flow
    const isFromRegisterPatient = state?.fromRegisterPatient === true
    const isFromConsult = state?.fromConsult === true
    const hasQueueInfo = state?.queue_no && state?.queue_id
    
    // Only show Add to Queue if coming from Register Patient or Consult flow
    if (isFromRegisterPatient || isFromConsult) {
      setCanShowAddToQueue(true)
    } else {
      setCanShowAddToQueue(false)
    }
    
    // Capture queue info from Consult button navigation FIRST (before fetchPatient)
    if (hasQueueInfo) {
      queueNoFromConsultRef.current = state.queue_no
      queueIdFromConsultRef.current = state.queue_id
      // Enable Add to Queue when coming from Consult button with queue info
      setEnableAddToQueue(true)
      enableAddToQueueRef.current = true
      setHasQueued(false)
      setQueueInfo({}) // Clear existing queue info to show Add to Queue button
    }
    
    fetchAllDoctors()
    checkIfPatientHasPriorAssessment()
    fetchPatient()
    fetchAllergy()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  // Fetch queue number only if NOT coming from Consult button
  useEffect(() => {
    if (patientDetails?.master_patient_id && !queueNoFromConsultRef.current) {
      fetchQueueNumber()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientDetails?.master_patient_id])
  useEffect(() => {
    if (isCheck) {
      setShowCheckupTabs(true)
    }
    fetchAssessmentHistory({ status: "ongoing" })
    setShowAppointmentModal(openAppointment)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCheck, openAppointment])

  useEffect(() => {
    if (!isLoading && showCheckupTabs) {
      targetDivRef.current?.scrollIntoView({ behavior: "smooth" })
    } else if (!isLoading && showLabForm) {
      laboratoryDivRef.current?.scrollIntoView({ behavior: "smooth" })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showCheckupTabs, showLabForm, isLoading])

  function useLocalStorage(key, initialValue) {
    const [value, setValue] = useState(() => {
      try {
        const item = window.localStorage.getItem(key)
        return item ? JSON.parse(item) : initialValue
      } catch (error) {
        return initialValue
      }
    })

    useEffect(() => {
      window.localStorage.setItem(key, JSON.stringify(value))
    }, [key, value])

    return [value, setValue]
  }

  useEffect(() => {
    if (role === "nurse") {
      setSelectedTab("medical_history")
    } else if (role !== "nurse" && medicalHistory === "medical_history") {
      setSelectedTab("medical_history")
    } else {
      setSelectedTab("assessment_history")
    }
  }, [role, medicalHistory])

  useEffect(() => {
    if (state?.fromQueueCheckUp) {
      setSelectedTab("assessment_history")
      setShowCheckupTabs(true)
    }
  }, [state])

  useEffect(() => {
    if (state?.selectedTab) {
      setSelectedTab(state.selectedTab)
    }
  }, [state?.selectedTab])

  useEffect(() => {
    // for fpe
    if (
      chiefComplaint &&
      chiefComplaint !== "" &&
      medicalHistory === "medical_history"
    ) {
      setComplaint(chiefComplaint)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chiefComplaint])

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  )

  return (
    <div className="App">
      <SidebarMenu active={"Patients"} />
      {isLoading ? (
        <div className="row p-5 pt-5 ps-3 mt-5 quill-cont">
          <TableSpinner />
        </div>
      ) : (
        <div className="col p-5 py-4 profile-container">
          <Row className="pt-2 p-3 patient-header">
            <Col xs={4} className="mt-2 patient-details">
              <Row>
                <Col xs={1}>
                  <img
                    src={backarrow}
                    alt="back"
                    className="backarrow"
                    width={25}
                    height={25}
                    onClick={() => navigateto(-1)}
                  ></img>
                </Col>
                <Col className="font-big font-bold ms-4 patient-details-title">
                  PATIENT DETAILS
                </Col>
              </Row>
            </Col>
            <Col xs={1}></Col>
            <Col className="">
              <Row className="profile-button buttons-payment">
                <Col className="header-btn">
                  {queueInfo.id ? (
                    <BtnSave
                      label={`Queue # ${queueInfo.queue_number}`}
                      disabled
                    />
                  ) : hasQueued && !enableAddToQueue ? (
                    <BtnSave label={"Queued"} disabled />
                  ) : canShowAddToQueue ? (
                    <BtnSave
                      label={"Add to Queue"}
                      onClick={() => setShowAddToQueueModal(true)}
                      disabled={isClicked || isQueueChecking || (!enableAddToQueue && hasQueued)}
                    />
                  ) : null}
                </Col>
                <Col className="header-btn">
                  <BtnSave
                    label={"Add Schedule"}
                    onClick={() => setShowAppointmentModal(true)}
                  />
                </Col>

                {role !== "nurse" && (
                  <Col className="header-btn">
                    {patientDetails?.assessment?.length !== 0 ? (
                      <BtnSave
                        label={"Cont. Check Up"}
                        onClick={() => {
                          setShowCheckupTabs(!showCheckupTabs)
                          setShowLabForm(false)
                          fetchAssessmentHistory({ status: "ongoing" })
                        }}
                      />
                    ) : (
                      <>
                        {medicalHistory === "" && (
                          <BtnSave
                            label={"Check Up"}
                            onClick={() => {
                              setShowCheckupTabs(!showCheckupTabs)
                              setShowLabForm(false)
                              fetchAssessmentHistory({ status: "ongoing" })
                            }}
                          />
                        )}
                      </>
                    )}
                  </Col>
                )}
              </Row>
            </Col>
          </Row>

          <Row>
            {/* PATIENT INFO */}
            <Col xl={2} className="profile-pic mb-4">
              <PatientCard
                patientDetails={patientDetails}
                onEditClick={handleEdit}
                onDeleteClick={() => setShowDelete(true)}
              />
              <AllergyCard allergyData={allergyData} />
            </Col>

            {/* PATIENT TABS */}
            <Col
              xl={10}
              align="right"
              className="profile-tab card-container medical-summary-pdf"
            >
              <Tabs
                activeKey={selectedTab}
                id="PO-tabs"
                type="card"
                animated="true"
                size="large"
                onChange={(e) => {
                  setSelectedTab(e)
                }}
              >
               <TabPane
                  key="social_personal_history"
                  tab="Social/Personal History"
                >
                  {selectedTab === "social_personal_history" && (
                    <AddSocialPersonal
                      smokingDatas={smokingData}
                      setSmokingDatas={setSmokingData}
                    />
                  )}
                </TabPane>
                <TabPane key="medical_history" tab="Medical History">
                  {selectedTab === "medical_history" && (
                    <AddMedical
                      allergyData={allergyData}
                      setAllergyData={setAllergyData}
                    />
                  )}
                </TabPane>
                <TabPane key="vital_signs" tab="Vital Signs">
                  {selectedTab === "vital_signs" && (
                    <VitalSigns
                      id={id}
                      sex={patientDetails.sex}
                      patientDetails={patientDetails}
                    />
                  )}
                </TabPane>
                <TabPane key="health_screening" tab="Health Screening">
                  {selectedTab === "health_screening" && (
                    <HealthScreening patientId={id} />
                  )}
                </TabPane>
                {role !== "nurse" && (
                  <>
                    <TabPane key="assessment_history" tab="Assessments">
                      {selectedTab === "assessment_history" && (
                        <AssessmentHistory patientId={id} />
                      )}
                    </TabPane>
                  </>
                )}
                {role !== "nurse" && (
                  <>
                    <TabPane key="lab_results" tab="Lab Results">
                      {selectedTab === "lab_results" && (
                        <LaboratoryResults
                          patientId={id}
                          showLabForm={handleShowLabForm}
                          setShowCheckupTabs={setShowCheckupTabs}
                        />
                      )}
                    </TabPane>
                  </>
                )}
                {role !== "nurse" && (
                  <>
                    <TabPane key="therapeutics" tab="Therapeutics">
                      {selectedTab === "therapeutics" && (
                        <TheraputicsHistory patientId={id} />
                      )}
                    </TabPane>
                  </>
                )}
                {role !== "nurse" && (
                  <>
                    <TabPane key="scanned_files" tab="Scanned Files">
                      {selectedTab === "scanned_files" && (
                        <PatientScannedProfile
                          patientId={id}
                          patientDetails={patientDetails}
                        />
                      )}
                    </TabPane>
                  </>
                )}
                {role !== "nurse" && (
                  <>
                    <TabPane key="forms" tab="Forms">
                      {selectedTab === "forms" && (
                        <Card>
                          {hasPriorAssessment ? (
                            <div style={{ minHeight: "100%" }}>
                              <div className="row">
                                <Tabs
                                  activeKey={selectedFormTab}
                                  id="PO-tabs"
                                  type="card"
                                  animated="true"
                                  size="large"
                                  onChange={(e) => {
                                    setSelectedFormTab(e)
                                  }}
                                >
                                  <TabPane
                                    key="medical_cert"
                                    tab="Medical Certificate"
                                  >
                                    {selectedFormTab === "medical_cert" && (
                                      <MedicalCertificateForm
                                        fileName={"MedicalCertificate.pdf"}
                                        isFetchData={selectedFormTab}
                                      />
                                    )}
                                  </TabPane>
                                  <TabPane
                                    key="referral_letter"
                                    tab="Referral Letter"
                                  >
                                    {selectedFormTab === "referral_letter" && (
                                      <ReferralLetterForm
                                        fileName={"ReferralLetter.pdf"}
                                        isFetchData={selectedFormTab}
                                      />
                                    )}
                                  </TabPane>
                                  <TabPane
                                    key="medical_abstract"
                                    tab="Medical Abstract"
                                  >
                                    {selectedFormTab === "medical_abstract" && (
                                      <MedicalAbstract
                                        id={id}
                                        isFetchData={selectedFormTab}
                                      />
                                    )}
                                  </TabPane>
                                  <TabPane
                                    key="medical_summary"
                                    tab="Medical Summary"
                                  >
                                    {selectedFormTab === "medical_summary" && (
                                      <MedicalSummary
                                        id={id}
                                        isFetchData={selectedFormTab}
                                      />
                                    )}
                                  </TabPane>
                                  <TabPane
                                    key="form_history"
                                    tab="Form History"
                                  >
                                    {selectedFormTab === "form_history" && (
                                      <FormHistory patientId={id} />
                                    )}
                                  </TabPane>
                                </Tabs>
                              </div>
                            </div>
                          ) : (
                            <Alert
                              variant="warning"
                              className="d-flex align-items-center"
                            >
                              <FontAwesomeIcon
                                fontSize={24}
                                icon={faCircleExclamation}
                              />
                              <span className="px-3">
                                Sorry, but you cannot generate medical forms for
                                a patient without prior assessment history.
                              </span>
                            </Alert>
                          )}
                        </Card>
                      )}
                    </TabPane>
                  </>
                )}
                <TabPane key="philhealth" tab="PhilHealth">
                  {selectedTab === "philhealth" && (
                    <Card>
                      <div style={{ minHeight: "100%" }}>
                        <div className="row">
                          <Tabs
                            activeKey={selectedPhilHealthTab}
                            id="PO-tabs"
                            type="card"
                            animated="true"
                            size="large"
                            onChange={(e) => {
                              setSelectedPhilHealthTab(e)
                            }}
                          >
                            <TabPane key="medical_record" tab="Medical Record">
                              {selectedPhilHealthTab === "medical_record" && (
                                <PhilHealthMedicalRecord
                                  patientDetails={patientDetails}
                                />
                              )}
                            </TabPane>
                            <TabPane key="konsulta" tab="eKonsulta">
                              {selectedPhilHealthTab === "konsulta" && (
                                <KonsultaManager
                                  patientDetails={patientDetails}
                                />
                              )}
                            </TabPane>
                          </Tabs>
                        </div>
                      </div>
                    </Card>
                  )}
                </TabPane>
                {role !== "nurse" && (
                  <>
                    <TabPane key="medical_chart" tab="Medical Chart">
                      {selectedTab === "medical_chart" && (
                        <MedicalChart patientDetails={patientDetails} />
                      )}
                    </TabPane>
                  </>
                )}
              </Tabs>
            </Col>
            {showCheckupTabs && role !== "nurse" && (
              <div ref={targetDivRef}>
                <CheckupTabs
                  assessment={assessment}
                  fetchAssessmentHistory={() =>
                    fetchAssessmentHistory({ status: "ongoing" })
                  }
                  complaint={state?.complaint || ""}
                  doctor_id={state?.doctor_id || ""}
                  selectedCheckUpTab={selectedCheckUpTab}
                  setSelectedCheckUpTab={setSelectedCheckUpTab}
                  patientDetails={patientDetails}
                  doctorOptions={doctors}
                  selectedTab={selectedTab}
                  setSelectedTab={setSelectedTab}
                  selectedFormTab={selectedFormTab}
                  setSelectedFormTab={setSelectedFormTab}
                />
              </div>
            )}

            {showLabForm && selectedTab === "lab_results" && (
              <>
                <div
                  ref={laboratoryDivRef}
                  className="col card-container three-buttons-labaratory"
                >
                  <Tabs
                    activeKey={selectedLabTab}
                    id="PO-tabs"
                    type="card"
                    animated="true"
                    size="large"
                    onChange={(e) => {
                      setSelectedLabTab(e)
                    }}
                  >
                    <TabPane key="laboratory" tab="Laboratory">
                      {selectedLabTab === "laboratory" && (
                        <Laboratory id={id} showLabForm={handleShowLabForm} />
                      )}
                    </TabPane>
                    {/* <TabPane key="radiology" tab="Radiology">
                        {
                          selectedLabTab === "radiology" &&(
                            <Radiology 
                              id={id} 
                              showLabForm={handleShowLabForm}
                            />
                          )
                        }
                      </TabPane> */}
                    <TabPane key="xray" tab="X-ray">
                      {selectedLabTab === "xray" && (
                        <Xray id={id} showLabForm={handleShowLabForm} />
                      )}
                    </TabPane>
                    <TabPane key="ultrasound" tab="Ultrasound">
                      {selectedLabTab === "ultrasound" && (
                        <Ultrasound id={id} showLabForm={handleShowLabForm} />
                      )}
                    </TabPane>
                    <TabPane key="ct_scan" tab="CT Scan">
                      {selectedLabTab === "ct_scan" && (
                        <CTScan id={id} showLabForm={handleShowLabForm} />
                      )}
                    </TabPane>
                    <TabPane key="other" tab="Others">
                      {selectedLabTab === "other" && (
                        <Others id={id} showLabForm={handleShowLabForm} />
                      )}
                    </TabPane>
                  </Tabs>
                </div>
              </>
            )}
          </Row>
          {/* <div className="mb-5"></div> */}
        </div>
      )}
      <AppointmentModal
        title={`Set Appointment Date`}
        show={showAppointmentModal}
        onHide={() => setShowAppointmentModal(false)}
        doctorsData={doctors}
        selectedDoctor={selectedDoctor}
        setSelectedDoctor={setSelectedDoctor} // Pass function to update doctor
        onConfirm={onSetAppointment}
        defaultDate={appointmentDate}
        setRescheduledDate={setAppointmentDate}
        saveTitle={`Save`}
        isClicked={isClicked}
      />
      {/* <AddToQueueModal
        patientId={id}
        show={showAddToQueueModal}
        onHide={() => {
          setComplaint("");
          setShowAddToQueueModal(false);
        }}
        complaint={complaint}
        onChange={(e) => setComplaint(e.target.value)}
        doctorsData={doctors}
        selectedDoctor={selectedDoctor}
        setSelectedDoctor={setSelectedDoctor} // Pass function to update doctor
        onConfirm={onAddToQueue}
        isClicked={isClicked}
      /> */}
      <AddToQueueModal
        patientId={id}
        show={showAddToQueueModal}
        onHide={() => setShowAddToQueueModal(false)}
        onConfirm={onAddToQueue}
        isClicked={isClicked}
      />
      <DeleteModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        title={"Do you want to delete this patient?"}
        onDelete={handleDeletePatient}
        isClicked={isClicked}
      />
      <RoutingSlipModal
        show={showRoutingSlipModal}
        onHide={() => setShowRoutingSlipModal(false)}
        customerDetail={patientDetails}
        allBooking={bookingResponse?.data?.bookings || bookingResponse?.bookings || []}
        bookingData={bookingResponse || {}}
        transactionNo={bookingResponse?.data?.transaction_no || bookingResponse?.transaction_no || ""}
        queueNo={queueInfo?.queue_no || ""}
        onPrintDone={handleRoutingSlipPrintDone}
      />
      {/* Hidden QueueSlip for printing */}
      <div style={{ position: "absolute", left: "-9999px", top: "-9999px", width: "520px" }}>
        <div ref={queueSlipRef} style={{ width: "520px" }}>
          <QueueSlip
            transaction_id=""
            emr_queue_no={printQueueNo}
            isCsr={true}
          />
        </div>
      </div>
    </div>
  )
}

export default PatientProfile
